/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_PendingInputs */

const en_st_mock_pending = /** @type {(inputs: St_Mock_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phase 2 is ready for review`)
};

const id_st_mock_pending = /** @type {(inputs: St_Mock_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fase 2 siap ditinjau`)
};

/**
* | output |
* | --- |
* | "Phase 2 is ready for review" |
*
* @param {St_Mock_PendingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_pending = /** @type {((inputs?: St_Mock_PendingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_PendingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_pending(inputs)
	return en_st_mock_pending(inputs)
});